import React, { useState } from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import './ScreenshotCarousel.css';

const screenshots = [
    '/Screenshots/HoldPhone_Graph.png',
    '/Screenshots/HoldPhone_Map.png',
    '/Screenshots/HoldPhone_List.png',
    '/Screenshots/HoldPhone_Card.png',
];

const ScreenshotCarousel = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [previousIndex, setPreviousIndex] = useState(0);
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);
    const [isTransitioning, setIsTransitioning] = useState(false);

    // Minimum swipe distance (in px)
    const minSwipeDistance = 50;

    const transitionToIndex = (newIndex) => {
        setPreviousIndex(currentIndex);
        setCurrentIndex(newIndex);
        setIsTransitioning(true);
        setTimeout(() => {
            setIsTransitioning(false);
        }, 500); // Match this with CSS transition duration
    };

    const goToNext = () => {
        if (isTransitioning) return;
        const newIndex = currentIndex === screenshots.length - 1 ? 0 : currentIndex + 1;
        transitionToIndex(newIndex);
    };

    const goToPrev = () => {
        if (isTransitioning) return;
        const newIndex = currentIndex === 0 ? screenshots.length - 1 : currentIndex - 1;
        transitionToIndex(newIndex);
    };

    const goToSlide = (index) => {
        if (isTransitioning || index === currentIndex) return;
        transitionToIndex(index);
    };

    const onTouchStart = (e) => {
        setTouchEnd(null);
        setTouchStart(e.targetTouches[0].clientX);
    };

    const onTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const onTouchEnd = () => {
        if (!touchStart || !touchEnd) return;

        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > minSwipeDistance;
        const isRightSwipe = distance < -minSwipeDistance;

        if (isLeftSwipe) {
            goToNext();
        } else if (isRightSwipe) {
            goToPrev();
        }
    };

    return (
        <div className="carousel-container">
            <div
                className="carousel-wrapper"
                onTouchStart={onTouchStart}
                onTouchMove={onTouchMove}
                onTouchEnd={onTouchEnd}
            >
                <button
                    className="carousel-arrow carousel-arrow-left"
                    onClick={goToPrev}
                    aria-label="Previous screenshot"
                >
                    <LeftOutlined />
                </button>

                <div className="carousel-content">
                    {isTransitioning && (
                        <img
                            src={screenshots[previousIndex]}
                            alt={`Screenshot ${previousIndex + 1}`}
                            className="carousel-image carousel-image-previous"
                        />
                    )}
                    <img
                        src={screenshots[currentIndex]}
                        alt={`Screenshot ${currentIndex + 1}`}
                        className={`carousel-image carousel-image-current ${isTransitioning ? 'fade-in' : ''}`}
                    />
                </div>

                <button
                    className="carousel-arrow carousel-arrow-right"
                    onClick={goToNext}
                    aria-label="Next screenshot"
                >
                    <RightOutlined />
                </button>
            </div>

            <div className="carousel-dots">
                {screenshots.map((_, index) => (
                    <button
                        key={index}
                        className={`carousel-dot ${index === currentIndex ? 'active' : ''}`}
                        onClick={() => goToSlide(index)}
                        aria-label={`Go to screenshot ${index + 1}`}
                    />
                ))}
            </div>
        </div>
    );
};

export default ScreenshotCarousel;
